export default __webpack_public_path__ + "static/media/jussiLogo.e005e337.svg";